import { Template } from './template';

export class UserTemplatesResponse {
    success: boolean;
    message: string;
    responseData: Template[];
    constructor() {
        this.responseData = [];
    }
}